import IconBase from '@/components/IconBase.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import BackButton from '@/components/BackButton.vue'
import Globals from '@/assets/scripts/global-functions.js'
import NextButton from '@/components/forms/ButtonNext.vue'

export default {
    name: 'TermsAndConditions',
    components: {
        IconBase,
        IconForwardBack,
        IconArrowBack,
        BackButton,
        NextButton
    },
    data () {
        return {
           
        }
    },
    methods: {
       Next() {
            this.$parent.EducatorNextStep(-1,"EducatorPayment"); 
            /*
            if(this.$parent[this.$parent.ReturnProcess()].PaymentInformation.plan == "year") {
                this.$parent.EditStatus = false;
                this.$parent.EducatorNextStep(-1,"EducatorPayment"); 
            } else {
                this.$parent.EditStatus = false;
                this.$parent.EducatorNextStep(-1,"PremiumFunding"); 
            }
            */
       },
       ValidateExistingData() {
            if(localStorage.getItem(this.$parent.ReturnProcess()) != undefined || localStorage.getItem(this.$parent.ReturnProcess()) != null || localStorage.getItem(this.$parent.ReturnProcess()) != "") {
                this.$parent[this.$parent.ReturnProcess()] = JSON.parse(localStorage.getItem(this.$parent.ReturnProcess()));
            }
        }
    },
    mounted () {
        this.ValidateExistingData();
        this.$parent.CheckWindowPathName();
    }
}